import clsx from 'clsx';
import { h } from 'preact';

// eslint-disable-next-line max-len
const SwatchItem = ({
  setCurrentProduct,
  setCurrentVariant,
  currentProduct,
  isActive,
  isSingleVariant,
  sizeOrder,
}) => {
  const sizeType = currentProduct?.burnedOption
    ? 'burnedOption'
    : 'widthOption';
  return (
    <div
      className={clsx(
        'rounded-[4px] relative border pt-[7px] pb-2.5 px-[5px] w-full',
        !currentProduct?.availableForSale &&
          'before:content-[""] before:block before:absolute before:w-full before:h-full before:bg-crossed before:top-0',
        isSingleVariant
          ? 'max-w-[220px]'
          : 'min-w-[calc(33%-6px)] max-w-[calc(33%-6px)] text-center desktop:max-w-[136px]',
        'flex flex-col items-center hover:border-black justify-start cursor-pointer',
        isActive
          ? 'border-black bg-cream-grey'
          : 'border-black-30 bg-transparent',
      )}
      style={{
        order: sizeOrder.indexOf(
          currentProduct?.sizeOption?.value.toLowerCase(),
        ),
      }}
      onClick={() => {
        setCurrentProduct(currentProduct);
        setCurrentVariant(currentProduct?.variants?.edges[0]?.node);
      }}
    >
      <p
        className={clsx(
          'text-black utility-1 leading-[1]',
          currentProduct[sizeType]?.value && 'mb-[7px]',
        )}
      >
        {currentProduct?.sizeOption?.value || ''}
      </p>
      {currentProduct[sizeType]?.value && (
        <p className="text-charcoal utility-1 leading-[1.1] laptop:leading-[1]">
          {currentProduct[sizeType]?.value}
        </p>
      )}
    </div>
  );
};

export default SwatchItem;
